<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{
            tipoMovimiento === "cobro" ? "Editar Cobro" : "Editar Pago"
          }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="fechaCobro"
                :value="fechaCobro"
                label="Fecha Cobro *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-select
                :items="profsBuscar"
                item-text="nombre"
                item-value="idCancha"
                menu-props="auto"
                label="Cancha *"
                hide-details
                prepend-icon="mdi-account"
                v-model="prof"
                :disabled="idTurno > 0 || esMercadoPago"
                dense
                no-data-text="No hay canchas registradas"
              ></v-select>
            </v-col>
            <v-col cols="9" sm="4" md="4">
              <v-text-field
                v-model="paciente"
                prepend-icon="mdi-account"
                :rules="requiredRules"
                label="Jugador *"
                :disabled="idTurno > 0 || esMercadoPago"
                @change="idPaciente = null"
                dense
                maxlength="150"
              ></v-text-field>
            </v-col>
            <v-col cols="2" sm="2" md="2" class="d-flex">
              <v-btn
                v-show="
                  !(idTurno > 0 || esMercadoPago) && tipoMovimiento === 'cobro'
                "
                color="primary"
                @click="buscarPaciente"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="observaciones"
                prepend-icon="mdi-account"
                label="Observaciones"
                :disabled="esMercadoPago"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" v-if="tipoMovimiento === 'cobro'">
              <v-select
                :items="formasPago"
                item-text="nombreFormaPago"
                item-value="idFormaPago"
                menu-props="auto"
                label="Forma de Pago *"
                hide-details
                prepend-icon="mdi-currency-usd"
                v-model="formaPago"
                dense
                :disabled="esMercadoPago"
                no-data-text="No hay Formas de Pago configuradas"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="2"
              class="checkbox"
              v-if="tipoMovimiento === 'cobro'"
            >
              <v-checkbox
                v-model="esSena"
                label="Es Seña"
                color="primary"
                dense
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="total"
                prepend-icon="mdi-currency-usd"
                :rules="
                  tipoMovimiento === 'cobro'
                    ? totalRulesCobros
                    : totalRulesPagos
                "
                label="Importe *"
                @blur="toFixed"
                @keypress="onlyNumber"
                dense
                :disabled="esMercadoPago"
                maxlength="10"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click.stop="show = false"
            >Cancelar</v-btn
          >
          <v-btn color="success" :disabled="!valid" @click.stop="modificarCobro"
            >Guardar</v-btn
          >
        </v-card-actions>
        <BuscarJugadorTurno
          :visible="showBuscarPaciente"
          @close="showBuscarPaciente = false"
          @seleccionarPaciente="seleccionarPaciente($event)"
        ></BuscarJugadorTurno>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
:deep(.checkbox) {
  .v-input--checkbox {
    margin-top: 0.6rem;
    padding-top: 0;
    &:first-child {
      margin-left: 1rem;
    }
    .v-input--selection-controls__input {
      margin-right: 2px;
    }
  }
}
</style>
<script>
import axios from "@/axios-auth";
import BuscarJugadorTurno from "@/components/Turnos/BuscarJugadorTurno.vue";
import { showAlert } from "@/utils/toast";
import moment from "moment";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    totalRulesCobros: [
      (v) => !!v || "Dato obligatorio",
      (v) => v >= 0 || "El total debe ser mayor o igual a 0",
    ],
    totalRulesPagos: [
      (v) => !!v || "Dato obligatorio",
      (v) => v > 0 || "El total debe ser mayor a 0",
    ],
    prof: "",
    profsBuscar: [],
    fechaCobro: null,
    paciente: null,
    observaciones: null,
    total: null,
    idTurno: null,
    idPaciente: null,
    showBuscarPaciente: false,
    formaPago: null,
    formasPago: [],
    linkMercadoPago: "",
    esSena: false,
    delta: false,
  }),
  props: {
    visible: { required: false },
    idCobro: { required: false },
    tipoMovimiento: { required: false, default: "cobro" },
    esMercadoPago: { required: false, default: false },
  },
  computed: {
    show: {
      get() {
        if (this.visible) this.buscarDatosCobro();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close", false);
        }
      },
    },
  },
  methods: {
    seleccionarPaciente(item) {
      (this.idPaciente = item.idpaciente),
        (this.paciente = item.apellidos + ", " + item.nombres);
      this.showBuscarPaciente = false;
    },
    buscarPaciente() {
      this.showBuscarPaciente = true;
    },
    modificarCobro() {
      if (moment(this.fechaCobro).isBefore(moment("1900-01-01"))) {
        showAlert({
          icon: "warning",
          title: `La fecha del ${
            this.tipoMovimiento === "cobro" ? "cobro" : "pago"
          } debe ser mayor o igual al 01/01/1900.`,
          timer: 2500,
          vm: this,
        });
        return;
      }
      const title =
        this.tipoMovimiento === "cobro" ? "Modificar Cobro" : "Modificar Pago";
      const text =
        this.tipoMovimiento === "cobro"
          ? "¿Desea modificar el cobro?"
          : "¿Desea modificar el pago?";
      this.$swal({
        title: title,
        text: text,
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosCobro = {
            fecha: this.fechaCobro,
            idTurno: this.idTurno,
            idPaciente: this.idPaciente,
            total:
              this.tipoMovimiento === "cobro"
                ? this.total
                : parseFloat(0 - this.total, 2).toString(),
            observaciones: this.observaciones,
            idProfesional: this.prof,
            paciente: this.paciente,
            idCobro: this.idCobro,
            idFormaPago:
              this.tipoMovimiento === "cobro" ? this.formaPago : null,
            usuario: this.$store.state.usuario.usuario,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            esSena: this.esSena,
          };
          let self = this;
          axios
            .post("/Caja/ModificarCobro", datosCobro)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels();
              document.getElementsByClassName(
                "v-dialog--active"
              )[0].scrollTop = 0;
              const alertTitle =
                self.tipoMovimiento === "cobro"
                  ? "Cobro modificado."
                  : "Pago modificado.";
              self.showAlert({
                icon: "success",
                title: alertTitle,
                vm: self,
                timer: 2000,
              });
              self.$emit("close", true);
            })
            .catch((error) => {
              const alertTitleError =
                self.tipoMovimiento === "cobro"
                  ? "El cobro no pudo ser modificado."
                  : "El pago no pudo ser modificado.";
              self.showAlert({
                icon: "warning",
                title: alertTitleError,
                vm: this,
                timer: 2000,
              });
            });
        }
      });
    },

    buscarDatosCobro() {
      this.profsBuscar = [...this.$store.state.usuario.canchas].sort((a, b) =>
        a.nombre.localeCompare(b.nombre)
      );

      this.prof = this.profsBuscar[0].idCancha;

      let self = this;
      axios.get("/Caja/BuscarFormasPago").then((response) => {
        self.formasPago = response.data;
      });

      const cobroData = {
        idCobro: this.idCobro,
      };

      axios
        .get("/Caja/BuscarDatosCobro?", {
          params: {
            idCobro: cobroData.idCobro,
          },
        })
        .then((response) => {
          self.fechaCobro = response.data.fecha.substring(0, 10);
          self.prof = response.data.idProfesional;
          self.paciente = response.data.paciente;
          self.observaciones = response.data.observaciones;
          self.total = parseFloat(response.data.total).toFixed(2);
          self.idTurno = response.data.idTurno;
          self.idPaciente = response.data.idPaciente;
          self.formaPago = response.data.idFormaPago;
          self.linkMercadoPago = response.data.linkMercadoPago ?? "";
          self.esSena = response.data.esSena;
        })
        .catch((error) => {});
    },

    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    toFixed() {
      if (isNaN(parseFloat(this.total)))
        this.total = parseFloat(0.0).toFixed(2);
      else this.total = parseFloat(this.total).toFixed(2);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    vaciarModels() {
      this.paciente = "";
      this.observaciones = "";
      this.total = "";
      this.esSena = false;
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },
  components: {
    BuscarJugadorTurno,
  },
};
</script>
